import { useState, useEffect, useCallback } from 'react';

export const useUserActivity = (inactivityTime = 900000) => { // 15 minutes
  const [isActive, setIsActive] = useState(true);
  const [lastActivity, setLastActivity] = useState(Date.now());

  // Throttle the update function to run at most once every 30 seconds
  const updateActivity = useCallback(() => {
    const now = Date.now();
    setIsActive(true);
    setLastActivity(now);
  }, [lastActivity]);

  useEffect(() => {
    // Events to track
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    
    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, updateActivity);
    });

    // Check for inactivity every minute
    const interval = setInterval(() => {
      const timeSinceLastActivity = Date.now() - lastActivity;
      if (timeSinceLastActivity >= inactivityTime) {
        setIsActive(false);
      }
    }, 300000);

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, updateActivity);
      });
      clearInterval(interval);
    };
  }, [inactivityTime, lastActivity, updateActivity]);

  return { isActive, lastActivity };
};
